import { UserProfile } from "../okta/userClaims";

export interface IFamilyMember {
  contractNumber: string;
  customerNumber: string;
  profileSeq: number;
  firstName: string;
  lastName: string;
  relationship: string;
  phoneNumber: string;
  emailAddress: string;
  transactionCode: number;
  profileStatus: string;
  abletofileClaim: string;
  avatarUrl: string;
  profileColor: string;
  contactConsent: string;
  language: string;
  id: string;
}

export interface IContract {
  id: string;
  dealerId: string;
  useGSSPClaims: boolean;

  /**
   * This is the policy/certificate number that identifies the policy that
   * provides coverage for PGH gadgets (sometimes called "home devices").
   *
   * Elita can have multiple child certificates which is why the Id field
   * of the Contract can't be assumed to be the correct policy/certificate
   * number.
   */
  certificateNumberForGadgetsPolicy: string;
  certificateNumberForPhonesPolicy: string;
  certificateNumberForClientSoldGadgetsPolicy: string;
  subscriberStatusCode: string;
  grossPolicyPrice: number;
  firstName: string;
  lastName: string;
  expirationDate: Date;
  cancellationDate?: Date;
  primaryUserEmail: string;
  zipCode: string;
  city?: string;
  state?: string;
  addressLine1?: string;
  members: IFamilyMember[];
  status: string;
  sku?: string;
  masterPlanCode: string;
  isMobilePlanActive?: boolean;
}

export interface IUserContract {
  elitaContracts: IContract[];
  eprismContracts: any[];
  userProfile: UserProfile;
}

export enum ContractStatusType {
  Active = 'A',
  Cancelled = 'C',
  Expired = 'E',
  Future = 'N'
}

export const getFamilyMemberSort = (primaryEmail, loggedInUserEmail) =>
  (a: IFamilyMember, b: IFamilyMember) => {
    // TODO: remove the self check after demo
    if (a.emailAddress === primaryEmail && a.relationship === 'Self' || a.emailAddress === loggedInUserEmail) {
      return -1;
    } else if (b.emailAddress === primaryEmail && b.relationship === 'Self' || b.emailAddress === loggedInUserEmail) {
      return 1;
    }

    return 0;
  };
